"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _programs = require("./programs");
Object.keys(_programs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _programs[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _programs[key];
    }
  });
});
var _logo = require("./logo");
Object.keys(_logo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _logo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _logo[key];
    }
  });
});